import React from "react";

const ToggleButton = ({
  value,
  checked,
  onToggle,
  activeLabel = "",
  inactiveLabel = "",
  colors,
  thumbStyle,
  trackStyle,
  disabled = false,
  ariaLabel,
}) => {
  const isChecked = checked ?? value ?? false;
  const activeTrackColor = colors?.active?.base || "#51B04A";
  const inactiveTrackColor = colors?.inactive?.base || "#CED4DA";
  const activeThumbColor = colors?.activeThumb?.base || "#FFFFFF";
  const inactiveThumbColor = colors?.inactiveThumb?.base || "#FFFFFF";

  return (
    <button
      type="button"
      aria-pressed={isChecked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => {
        if (!disabled && onToggle) {
          onToggle(isChecked);
        }
      }}
      style={{
        width: 46,
        height: 24,
        border: "none",
        padding: 2,
        display: "inline-flex",
        alignItems: "center",
        borderRadius: 999,
        cursor: disabled ? "not-allowed" : "pointer",
        backgroundColor: isChecked ? activeTrackColor : inactiveTrackColor,
        transition: "background-color 0.2s ease",
        ...trackStyle,
      }}
    >
      {isChecked ? activeLabel : inactiveLabel}
      <span
        style={{
          width: 20,
          height: 20,
          display: "inline-block",
          borderRadius: 999,
          backgroundColor: isChecked ? activeThumbColor : inactiveThumbColor,
          transform: `translateX(${isChecked ? 22 : 0}px)`,
          transition: "transform 0.2s ease, background-color 0.2s ease",
          ...thumbStyle,
        }}
      />
    </button>
  );
};

export default ToggleButton;
